import { render } from "./PayInItem.vue?vue&type=template&id=bbae4158&scoped=true"
import script from "./PayInItem.vue?vue&type=script&lang=js"
export * from "./PayInItem.vue?vue&type=script&lang=js"

import "./PayInItem.vue?vue&type=style&index=0&id=bbae4158&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbae4158"]])

export default __exports__